<nav class="pagination" aria-label="Pagination">
  <button
    class="pagination-btn pagination-nav"
    [disabled]="!canGoPrevious()"
    (click)="previousPage()"
  >
    &lsaquo; Prev
  </button>

  @for (page of pages(); track page.value) {
    @if (page.type === 'ellipsis') {
      <span class="pagination-ellipsis">&hellip;</span>
    } @else {
      <button
        class="pagination-btn pagination-page"
        [class.active]="page.value === currentPage()"
        (click)="goToPage(page.value)"
      >
        {{ page.value }}
      </button>
    }
  }

  <button
    class="pagination-btn pagination-nav"
    [disabled]="!canGoNext()"
    (click)="nextPage()"
  >
    Next &rsaquo;
  </button>
</nav>
